import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import clsx from 'clsx';
import Dropdown from "../../Dropdown";
import {
AccountCircle,
ExitToApp,
Help,
Menu,
PeopleOutline,
AssignmentInd,
Book,
InsertChart,
PeopleGroup,
Star } from "../../../icons";

import { OptionsAlignmentTypes } from "../../../types/Dropdown";

import { adminRights, celticsRights, eeRights, userAccessRights } from "../../../utils/accessRights";
import { HeaderLinksRoutes } from "../index";
import { createStyles } from "./styles";







var MobileHeaderNavDropdown = function MobileHeaderNavDropdown(props) {
  var classes = createStyles(props);
  var DropdownElement = function DropdownElement(_ref) {var href = _ref.href,linkText = _ref.linkText,icon = _ref.icon;
    return /*#__PURE__*/(
      React.createElement("li", { className: classes.mobileDropdownOption }, /*#__PURE__*/
      React.createElement("a", { href: href, className: classes.mobileDropdownLink }, /*#__PURE__*/
      React.createElement("span", { className: classes.mobileDropdownIcon }, icon), /*#__PURE__*/
      React.createElement("span", { className: classes.mobileDropdownLinkText }, linkText))));



  };
  var MobileDropdownOptions = [
  {
    value: HeaderLinksRoutes.HELP,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, { key: key, href: HeaderLinksRoutes.HELP, linkText: "Help", icon: /*#__PURE__*/React.createElement(Help, null) }));}

  },
  {
    value: HeaderLinksRoutes.CHANGE_AGENCY,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.CHANGE_AGENCY,
          linkText: "Agency",
          icon: /*#__PURE__*/React.createElement(AssignmentInd, null) }));}


  },
  {
    value: HeaderLinksRoutes.ACCOUNT_SETTINGS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.ACCOUNT_SETTINGS,
          linkText: "Settings",
          icon: /*#__PURE__*/React.createElement(AccountCircle, null) }));}


  }];


  var LogoutDropdownOption = {
    value: HeaderLinksRoutes.LOGOUT,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.LOGOUT,
          linkText: "Logout",
          icon: /*#__PURE__*/React.createElement(ExitToApp, null) }));}


  };

  var BiDashboardOption = {
    value: HeaderLinksRoutes.BI_DASHBOARD,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.BI_DASHBOARD,
          icon: /*#__PURE__*/React.createElement(PeopleGroup, null),
          linkText: "BI Dashboard" }));}


  };

  var FavoriteProposalOption = {
    value: HeaderLinksRoutes.FAVORITE_PROPOSALS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.FAVORITE_PROPOSALS,
          icon: /*#__PURE__*/React.createElement(Star, null),
          linkText: "Favorite Proposals" }));}


  };

  var ManageUsersOption = {
    value: HeaderLinksRoutes.USER_SERVICE,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.USER_SERVICE,
          icon: /*#__PURE__*/React.createElement(PeopleOutline, null),
          linkText: "Users" }));}


  };

  var MobileAdminUserDropdownOptions = [
  ManageUsersOption,
  {
    value: HeaderLinksRoutes.BOOK_OF_BUSINESS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.BOOK_OF_BUSINESS,
          icon: /*#__PURE__*/React.createElement(Book, null),
          linkText: "Book Of Business" }));}


  },
  {
    value: HeaderLinksRoutes.INSIGHTS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(DropdownElement, {
          key: key,
          href: HeaderLinksRoutes.INSIGHTS,
          icon: /*#__PURE__*/React.createElement(InsertChart, null),
          linkText: "Insights" }));}


  }];


  var EmployeeDropdownOptions = [LogoutDropdownOption];

  // Component actions
  function createMobileUserDropdownOptions() {var _context;
    var resultOptions = _concatInstanceProperty(_context = []).call(_context, MobileDropdownOptions);
    if (eeRights(props.currentUserRoles)) {
      return EmployeeDropdownOptions;
    }
    if (props.showTools && !userAccessRights(props.currentUserRoles)) {
      if (adminRights(props.currentUserRoles)) {
        resultOptions.push.apply(resultOptions, MobileAdminUserDropdownOptions);
      }
      if (celticsRights(props.currentUserRoles)) {
        resultOptions.push(BiDashboardOption);
      }
      resultOptions.push(FavoriteProposalOption);
    }

    if (props.showTools && userAccessRights(props.currentUserRoles)) {
      resultOptions.push(ManageUsersOption);
    }
    resultOptions.push(LogoutDropdownOption);
    return resultOptions;
  }

  return /*#__PURE__*/(
    React.createElement(Dropdown, {
      name: "mobileNavDropdown",
      options: createMobileUserDropdownOptions(),
      optionsAlignment: OptionsAlignmentTypes.BOTTOM_LEFT,
      optionsWidth: "16rem",
      closedElement: /*#__PURE__*/
      React.createElement("button", {
        type: "button",
        className: clsx(classes.mobileDropdownButton, classes.mobileDropdownButtonClosed) }, /*#__PURE__*/

      React.createElement(Menu, null)),


      openedElement: /*#__PURE__*/
      React.createElement("button", {
        type: "button",
        className: clsx(classes.mobileDropdownButton, classes.mobileDropdownButtonOpened) }, /*#__PURE__*/

      React.createElement(Menu, null)) }));




};

export default MobileHeaderNavDropdown;
//# sourceMappingURL=index.js.map